<template>
  <div id="app" class="app-wrapper">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',

  data() {
    return {
      isAmisApp: false,
      isinterface:0,//是否是接口
    };
  },
  created() {
    this.isinterface = this.$route.query.isinterface
    if(this.isinterface == undefined) {
      this.isinterface = 0
    }

  },
  methods:{

  }
}
</script>

<style>
body{
  padding: 0px;
  margin: 0px;
  background-color: #F0F2F5;
  font-family: 'Avenir', Helvetica, Arial, sans-serif, -apple-system, BlinkMacSystemFont, "SF Pro SC", "SF Pro Text", "Helvetica Neue", "PingFang SC", "Segoe UI", Roboto, "Hiragino Sans GB", SimSun !important;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif, -apple-system, BlinkMacSystemFont, "SF Pro SC", "SF Pro Text", "Helvetica Neue", "PingFang SC", "Segoe UI", Roboto, "Hiragino Sans GB", SimSun !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*color: #2c3e50;*/
}
div:not(.codicon){
  font-family: 'Avenir', Helvetica, Arial, sans-serif, -apple-system, BlinkMacSystemFont, "SF Pro SC", "SF Pro Text", "Helvetica Neue", "PingFang SC", "Segoe UI", Roboto, "Hiragino Sans GB", SimSun !important;
}
.app-wrapper {
  position: relative;
  width: 100%;
  height:100%;
  margin: 0;
  padding: 0;
  overflow: auto;
}
.app-wrapper_i {
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow: auto;
}
.text-shenglue{
	display:block;
	word-break:keep-all;
	white-space:nowrap;
	overflow:hidden;
	text-overflow:ellipsis;
	-o-text-overflow:ellipsis;
	-icab-text-overflow:ellipsis;
	-khtml-text-overflow:ellipsis;
	-moz-text-overflow: ellipsis;
	-webkit-text-overflow:ellipsis;
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.right-screen {
  display: flex;
  justify-content: flex-start;
  font-size: 14px;
  margin-bottom: 15px;
}
.screen-label {
  margin: 5px 20px 5px 0;
  color: #333;
}
.screen-main {
  width: 92%;
  color: #666;
}
.screen-main-col {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.screen-main-col li {
  padding: 5px 12px;
  cursor: pointer;
}
.screen-main-col .curr-industry {
  background: #2AC9DF;
  color: #fff;
  border-radius: 5px;
}
.template-info {
  display: flex;
  align-items: center;
}
.template-img {
  margin-right: 10px;
}
.template-title h4{
  margin: 0;
}
.template-label li {
  float: left;
  margin-right: 8px;
}
.paging {
  display: flex;
  padding: 15px 0 10px 0;
}
.el-tabs__item.is-left.is-active{
  margin: 2px;
  background-color: #2AC9DF;
  color: white;
  box-shadow:2px 2px 6px #5E5E5E;
}
.large-content-div {
  position: absolute;
  top: 60px;
  left: 8px;
  background: #fff;
  box-shadow:2px 2px 6px #5E5E5E;
}
/*修改滚动条样式*/
div::-webkit-scrollbar {
  width:8px;
  height:8px;
  /**/
}
div::-webkit-scrollbar-track{
  background: rgb(239, 239, 239);
  border-radius:2px;
}
div::-webkit-scrollbar-thumb{
  background: #bfbfbf;
  border-radius:4px;
}
div::-webkit-scrollbar-thumb:hover{
  background: #7f7f7f;
}
div::-webkit-scrollbar-corner{
  background: #FFFFFF;
}
</style>
